import React, { useEffect, useState } from "react";
import { About } from "./About";
import { BoardGame } from "./BoardGame";
import { Projects } from "./Projects";
import { Footer } from "./XFooter";

export function Body() {
  const [Screen, setScreen] = useState(window.innerWidth);

  useEffect(() => {
    const windowResize = () => {
      setScreen(window.innerWidth);
    };
    window.addEventListener("resize", windowResize);

    return () => {
      window.removeEventListener("resize", windowResize);
    };
  }, []);

  let getClassNames = () => {
    return Screen > 1200 ? "-horrizontal" : "-vertical";
  };

  return (
    <div>
      <div className="main">
        <About view={getClassNames()} />

        <Projects view={getClassNames()} />
      </div>

      <div className="game">
        <BoardGame view={getClassNames()} />
      </div>
      <Footer />
    </div>
  );
}
